import { t } from "i18next";
import { Loader2 } from "lucide-react";
import type { JSX } from "react";

/**
 * v3.2: after Stop, while the visit is created with the recorder's template.
 * The visit then opens and its note is written there.
 */
export const RecorderNoteWriting = ({
  templateName,
  title,
  hint,
}: {
  templateName: string;
  // A recording added to a visit: its own wording.
  title?: string;
  hint?: string;
}): JSX.Element => (
  <div
    className="flex w-full flex-col items-center gap-3 px-8 text-center font-v3"
    data-testid="recorder-v32-writing"
    role="status"
  >
    <span className="flex h-14 w-14 items-center justify-center rounded-full bg-v3-brand-tint text-v3-brand-strong">
      <Loader2 aria-hidden className="h-6 w-6 animate-spin" />
    </span>
    <p className="text-[17px] font-semibold text-v3-text">
      {title ?? t("recorderV32.writing.title")}
    </p>
    <p className="max-w-[300px] text-[14px] leading-5 text-v3-text-3">
      {hint ?? t("recorderV32.writing.hint", { template: templateName })}
    </p>
  </div>
);
